import { ECRITURE_LOCK_LABELS, type KeptEcriture } from '@cpce/shared';
import { TriangleAlert } from 'lucide-react';
import { Tooltip } from '@/components/Tooltip';

export const describeKeptEcriture = (entry: KeptEcriture) => {
  const where = entry.accountCode ? ` (${entry.accountCode})` : '';
  const why = entry.lock
    ? ECRITURE_LOCK_LABELS[entry.lock]
    : 'plus verrouillée, appliquez à nouveau la modification pour la reprendre';
  return `${entry.reference}${where} : ${why}`;
};

interface KeptEcrituresIndicatorProps {
  entries: KeptEcriture[];
  /** What the écritures were left out of, e.g. « Écritures restées sur un autre compte ». */
  title: string;
}

/** The écritures a change after the fact left as they were: a ⚠ count, detailed on hover. */
export function KeptEcrituresIndicator({ entries, title }: KeptEcrituresIndicatorProps) {
  if (entries.length === 0) return null;
  return (
    <Tooltip text={`${title} — ${entries.map(describeKeptEcriture).join(' ; ')}`}>
      <span className="inline-flex items-center gap-1 text-sm text-orange-600">
        <TriangleAlert className="size-4" />
        {entries.length}
      </span>
    </Tooltip>
  );
}
